import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import R, { not, isEmpty } from 'ramda';
import { CircularProgress } from 'material-ui';
import SelectMethod from './select-method';
import ReviewPartners from './review-partners';
import ExistingPartners from './existing/container-existing';
import ImportFromEmail from './import-from-email';
import UploadFile from './upload-file';
import AddIndividually from './add-individually';
import { getPartnersForMM } from '../../../stores/marketing-materials/actions';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
class SendToPartners extends React.Component {
  componentWillMount() {
    if (isNilOrEmpty(this.props.MMPartnerReducer.existingConnections)) this.props.getPartnersForMM();
  }
  render() {
    const {
      MMPartnerReducer,
      updateMMPartnerProp,
      isSupplier,
    } = this.props;

    const clearReducer = () => updateMMPartnerProp({
      sendToPartners: false,
      partnersToSendTo: [],
      filteredConnections: [],
      addPartnersMethod: '',
      showSelectMethod: false,
      individualCompanyName: '',
      individualEmail: '',
      searchField: '',
      selectedExistingPartners: [],
    });

    const sharedProps = {
      updateMMPartnerProp,
      clearReducer,
    };

    const actionItems = [
      {
        text: 'Select from connections',
        icon: 'tc-icon-user',
        func: () => updateMMPartnerProp({
          addPartnersMethod: 'fromConnections',
          showSelectFromPartnersDialog: true,
        }),
      },
      {
        text: 'Import from email',
        icon: 'tc-icon-email',
        func: () => updateMMPartnerProp({
          addPartnersMethod: 'emailImport',
          showEmailImportDialog: true,
        }),
      },
      {
        text: 'Upload a file',
        icon: 'tc-icon-insert-drive-file',
        func: () => updateMMPartnerProp({
          addPartnersMethod: 'uploadFile',
          showUploadFileDialog: true,
        }),
      },
      {
        text: 'Add individually',
        icon: 'add-circle-icon',
        func: () => updateMMPartnerProp({
          addPartnersMethod: 'addIndividually',
          showAddIndividuallyDialog: true,
        }),
      },
    ];

    const getSelectedMethod = () => {
      switch (MMPartnerReducer.addPartnersMethod) {
        case 'fromConnections':
          return (
            <ExistingPartners
              {...sharedProps}
            />
          );
        case 'emailImport':
          return (
            <ImportFromEmail
              {...sharedProps}
            />
          );
        case 'uploadFile':
          return (
            <UploadFile
              {...sharedProps}
            />
          );
        case 'addIndividually':
          return (
            <AddIndividually
              {...sharedProps}
            />
          );
        default:
          return (<span/>);
      }
    };

    return (
      <div style={{ marginTop: '-3%' }}>
        {
          MMPartnerReducer.sendToPartners ?
            <div>
              {not(isEmpty(MMPartnerReducer.addPartnersMethod)) ? getSelectedMethod() : <span/>}
              <ReviewPartners
                actionItems={actionItems}
                isSupplier={isSupplier}
                {...sharedProps}
              />
            </div> : <span/>
        }
        {
          MMPartnerReducer.sendingMM ?
            <div style={{ marginTop: '20px', display: 'block', textAlign: 'center' }}>
              <CircularProgress />
              <br/>
              Sending Marketing Materials to your partners.
            </div> : <span/>
        }
      </div>
    );
  }
}

SendToPartners.propTypes = {
  MMPartnerReducer: PropTypes.object,
  updateMMPartnerProp: PropTypes.func,
  isSupplier: PropTypes.bool,
  getPartnersForMM: PropTypes.func,
};

const mapStateToProps = ({ marketingMaterials }) => ({
  MMPartnerReducer: marketingMaterials.partnerReducer.toJS(),
});

export default connect(mapStateToProps, { getPartnersForMM })(SendToPartners);



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/send-to-partners/container-send-to-partners.jsx